/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrUrinaryProteinTypename = "PhrUrinaryProtein" as const;

/**
 *
 * @export
 * @interface PhrUrinaryProtein
 */
export interface PhrUrinaryProtein {
  /**
   *
   * @type {string}
   * @memberof PhrUrinaryProtein
   */
  autoMatic?: string;
  /**
   *
   * @type {string}
   * @memberof PhrUrinaryProtein
   */
  manual?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrUrinaryProtein
   */
  readonly __typename?: string;
}

export function PhrUrinaryProteinFromJSON(json: any): PhrUrinaryProtein {
  return PhrUrinaryProteinFromJSONTyped(json, false);
}

export function PhrUrinaryProteinFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrUrinaryProtein {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrUrinaryProteinTypename,

    autoMatic: !exists(json, "auto_matic") ? undefined : json["auto_matic"],
    manual: !exists(json, "manual") ? undefined : json["manual"],
  };
}

export function PhrUrinaryProteinToJSON(object?: PhrUrinaryProtein | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    auto_matic: value.autoMatic,
    manual: value.manual,
  };
}
